export default "__VITE_ASSET__BwNeGksE__"